function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { FiArrowRight } from 'react-icons/fi';
import { Body, CallToAction } from '../../atoms';
export default function LabeledCallToAction(param) {
    var label = param.label, action = param.action, className = param.className, contentClassName = param.contentClassName;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge('flex w-full md:w-auto', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('flex flex-col items-center rounded-xl bg-bg-subtle py-5 px-6 w-full md:w-auto md:rounded-full md:flex-row', contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 text-center md:mb-0 md:mr-5 md:text-left"
    }, /*#__PURE__*/ React.createElement(Body, null, label)), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-full md:w-auto md:flex-row"
    }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, action), {
        buttonType: "icon-after",
        icon: /*#__PURE__*/ React.createElement(FiArrowRight, null)
    })))));
}

//# sourceMappingURL=LabeledCallToAction.js.map